export default "__VITE_ASSET__DiZi20TW__"